
import useAuthBackground from './AuthBackground';

export default {
  setup() {
    return useAuthBackground();
  },
};
